import TextArea from "@/components/TextArea";
import CapsuleGallery from "@/components/Triggers/CapsuleGallery";
import { ArtistSelector } from "@/modules/editor/components/common/ArtistSelector";
import { SizeSelector } from "@/modules/editor/components/common/SizeSelector";
import { StyleSelector } from "@/modules/editor/components/common/StyleSelector";
import { Txt2ImgSubmitButton } from "@/modules/editor/components/common/Txt2ImgSubmitButton";
import { LabelText } from "@/modules/editor/components/styleComponents/Texts";
import {
  setTxt2ImgArtist,
  setTxt2ImgCat,
  setTxt2ImgCatTexts,
  setTxt2ImgStyle,
  statusStore,
} from "@/stores/status";
import { allTxt2ImgCats } from "@/utils/constants";
import { Editor_Words } from "@/utils/lang/editor";
import { getTxt2imgGenerateSize, useOwnToast } from "@/utils/misc";
import { langStore, translate, useSelecting } from "@noli/business";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";

const ICatPanel: React.FC = () => {
  const t = useOwnToast();
  const lang = langStore.tgt;
  const {
    txt2imgCatTexts: text,
    txt2imgCat,
    txt2imgStyle,
    txt2imgArtist,
    txt2imgSize,
  } = statusStore;

  const { displayNode } = useSelecting("raw");
  const info = useSelecting("basic")({ fixed: 0 });

  const showSizeSelectorMessage =
    displayNode?.type === "rectangle" || displayNode?.type === "image";

  const { w, h } = useMemo(
    () =>
      showSizeSelectorMessage && displayNode
        ? { w: info?.w ?? 0, h: Math.abs(info?.h ?? 0) }
        : getTxt2imgGenerateSize(txt2imgSize),
    [txt2imgSize, showSizeSelectorMessage, displayNode, info],
  );
  return (
    <>
      <CapsuleGallery
        panelTitle={translate(Editor_Words["generate-cats-category"], lang)}
        storeValue={txt2imgCat}
        setStoreValue={setTxt2ImgCat}
        words={allTxt2ImgCats as any}
      />
      <StyleSelector mt="16px" value={txt2imgStyle} setValue={setTxt2ImgStyle} />
      <ArtistSelector mt="16px" value={txt2imgArtist} setValue={setTxt2ImgArtist} />
      <LabelText mt="16px">{translate(Editor_Words["generate-cats-description"], lang)}</LabelText>
      <TextArea
        w="100%"
        mt="16px"
        mb="16px"
        lang={lang}
        textAreaH={42}
        textAreaExpandH={200}
        minRows={5}
        maxRows={10}
        placeholderWord={Editor_Words["prompt-for-img-input-placeholder"]}
        text={text}
        setText={setTxt2ImgCatTexts}
      />
      <SizeSelector showSizeSelectorMessage={showSizeSelectorMessage} />
      <Txt2ImgSubmitButton
        mt="48px"
        t={t}
        size={{ w, h }}
        lang={lang}
        text={text}
        circular={false}
        modelType="nolibox"
        canIgnoreText
        extraPromptInfo={{ cat: txt2imgCat }}
        defaultBusyAlias=".onPresetCat."
        calcPriceProps={{
          basePrice: 1,
          unitPrice: 2,
        }}
      />
    </>
  );
};

export const CatPanel = observer(ICatPanel);
